import React from "react";
import {
  Dialog,
  DialogContent,
  Paper,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DialogContentWrapper = ({ open, onClose, title, icon, children }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
    <DialogContent sx={{ padding: "0" }}>
      <Paper elevation={3} sx={{ padding: "10px", backgroundColor: "#f5f5f5" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              padding: 1,
              fontFamily: "NBA Font",
            }}
          >
            {icon}{" "}
            <Typography variant="subtitle1" color="primary" fontWeight={600}>
              {title}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon color="error" />
          </IconButton>
        </Box>
      </Paper>
      {children}
    </DialogContent>
  </Dialog>
);

export default DialogContentWrapper;
